<template>
  <div class="mainContent paymentPage pd20">
    <transition-group name="fadeCustom" tag="div" class="wrapper messagesWrapper">
      <Messages
          v-if="messages.length"
          v-for="(message, index) in messages"
          :key="index + 0"
          v-bind="message"
          :i="index"
      />
    </transition-group>
    <div v-if="planSummaryVisible" class="planSummaryWrap">
      <div class="planSummary frameMobile center">
<!--        <div class="titleWrap">-->
<!--          <h2><span v-if="$mq!=='lg'">{{ 'pages/payment.great' | trans }}</span>-->
<!--            <span v-if="$mq=='lg'">{{ 'pages/payment.well-done' | trans }}</span>!</h2>-->
<!--        </div>-->

        <PulseLoader v-if="paymentInstalmentLoading" size="8px" color="#00B2FF"/>
        <div v-else class="summaryDescription">
          <div class="summaryDescriptionContent">
            <div class="title smaller">
              {{ 'pages/payment.payment-taken' | trans }}
            </div>
          </div>
<!--          <router-link to="/" class="btn btn-block">{{ 'pages/payment.button.ok' | trans }}</router-link>-->
        </div>
      </div>
    </div>
    <div v-if="paymentVisible" class="paymentWrap">
      <div v-if="$mq=='lg'" class="titleWrap mainPageTitle">
        <h2>{{ 'pages/payment.process-payment' | trans }}</h2>
      </div>

      <PulseLoader v-if="paymentInstalmentLoading" size="8px" color="#00B2FF"/>
      <Amount v-else
              @setAmountType="amountType = $event"
              :amountType="amountType"
              @setCustomAmountValue="customAmountValue = $event"
              :customAmountValue="fullAmountValue < customAmountValue ? parseFloat(fullAmountValue) : parseFloat(customAmountValue)"
              :instalmentAmountValue="instalmentAmountValue ? parseFloat(instalmentAmountValue) : 0"
              :fullAmountValue="fullAmountValue ? parseFloat(fullAmountValue) : 0"
              :outstandingBillAmountValue="outstandingBillAmountValue ? parseFloat(outstandingBillAmountValue) : 0"
      />
      <div class="processPayment frameMobile" v-if="selectedAmount">
        <h3>{{ 'pages/payment.process-payment' | trans }}</h3>

          <PaymentOptions
              v-if="jurisdiction === 'DE' "
              @setPaymentOption="paymentOption = $event"
              :paymentOption="paymentOption"
          />

          <Worldpay3dsIframe
              v-if="worldpay3dsIframeVisible"
              :url="worldpay3dsUrl"
              @process3ds="worldpay3dsEvent"
          />

          <div v-if="!worldpay3dsIframeVisible">
            <div v-if="(paymentOption === 'creditCards' || jurisdiction !== 'DE') && userDataloaded == true "
                 class="cardsWrapper">


              <PulseLoader v-if="paymentActiveCardLoading" size="8px" color="#00B2FF"/>
              <RegisteredCard
                  v-if="registeredCardPan"
                  :registeredCardPan="registeredCardPan"
                  :registeredPaymentMethodId="registeredPaymentMethodId"
                  :loading="paymentRegisteredCardLoading"
                  @processPayment="processRegisteredCardPayment"
              />

              <div v-if="registeredCardPan"
                   class="or">
                <hr>
                <span>{{ 'pages/payment.or' | trans }}</span>
                <hr>
              </div>

              <NewCard
                  :expiryDateMonth="''"
                  :expiryDateYear="''"
                  :name-on-card="''"
                  :pan="''"
                  :cvv="''"
                  :loading="paymentNewCardLoading"
                  :submitButtonLabel="'pages/payment.button.process-payment' | trans"
                  ref="newCardRef"
                  @submitCard="processNewCardPayment"
              >
                <div class="selectWrap" :class="{'hasError' : billingAddressError}">
                  <label>{{ 'pages/payment.billing-address' | trans }}</label>
                  <v-select
                      :options="addresses"
                      v-model="selectedAddress"
                      :placeholder="'pages/payment.select-address' | trans"
                      class="formSelect"
                      :reduce="address => address.value"
                  />
                  <div class="error" v-if="billingAddressError">
                    {{ 'pages/payment.billing-address-required' | trans }}
                  </div>
                </div>
                <div class="useForFuturePayments">
                  <h4 class="title">{{ 'pages/payment.use-card-for-all-payments' | trans }}</h4>
                  <Switcher v-model="useForFuturePayments"/>
                </div>
              </NewCard>
            </div>
          </div>

          <div v-if="paymentOption === 'sofort'" class="sofortWrapper">
            <PulseLoader v-if="loader" size="8px" color="#00B2FF"/>
            <div v-else>
              <button type="button" name="sofortPay" class="btn sofortMakePayment" @click="sofortMakePayment">
                {{ 'pages/payment.button.process-payment' | trans }}
              </button>
            </div>
          </div>
		  </div>
      </div>

    </div>
  </div>
</template>

<script>
import Switcher from '../components/form/Switcher';
import Amount from '../components/Payment/Amount';
import Worldpay3dsIframe from '../components/Payment/Worldpay3dsIframe';
import PaymentOptions from '../components/Payment/PaymentOptions';
import RegisteredCard from '../components/Payment/RegisteredCard';
import ProvideCard from '../components/Payment/ProvideCard';
import NewCard from '../components/Settings/NewCard';
import {mapActions, mapState} from 'vuex';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import helper from '../services/helper';
import vSelect from '../components/temp/MyVueSelect';
import Messages from '../components/messages/Message';

export default {
  props: ['loading'],
  data() {
    return {
      amountType: 'custom',
      customAmountValue: 0,
      outstandingBillAmountValue: 0,
      instalmentAmountValue: 0,
      fullAmountValue: 0,
      registeredCardPan: null,
      registeredPaymentMethodId: null,
      useForFuturePayments: false,
      paymentNewCardLoading: false,
      paymentRegisteredCardLoading: false,
      selectedAddress: null,
      billingAddressError: false,
      worldpay3dsIframeVisible: false,
      planSummaryVisible: false,
      paymentVisible: true,
      customAmountVisible: true,
      paymentOption: '',
      jurisdiction: 'GB',
      sofortListenUrlIntervalRef: '',
      userDataloaded: false,
      worldpay3dsUrl: null
    }
  },
  components: {
    Amount,
    PaymentOptions,
    RegisteredCard,
    Worldpay3dsIframe,
    ProvideCard,
    PulseLoader,
    NewCard,
    Switcher,
    vSelect,
    Messages
  },
  methods: {
    ...mapActions(['getPaymentInstalment', 'getRegisteredActiveCard', 'getUserInfo', 'ddMessage', 'addMessage', 'getAddresses']),

    getInstalmentAmount: function () {
      return this.user.instalment ? this.user.instalment.amount : 0;
    },
    getOutstandingBillAmount: function () {
      return this.user.bill ? this.user.bill.outstanding_total : 0;
    },
    getJurisdiction: function () {
      return this.user.jurisdiction ? this.user.jurisdiction : 'GB';
    },
    processNewCardPayment: function (payload) {
      if (!this.selectedAddress) {
        this.billingAddressError = true;
        return;
      }

      let submitCardPayload = {
        cvv: payload.cvv,
        month: payload.month,
        year: payload.year,
        nameOnCard: payload.nameOnCard,
        pan: payload.pan,
        useForFuturePayments: this.useForFuturePayments,
        amount: this.getSelectedAmount(),
        addressId: this.selectedAddress
      };


      this.paymentNewCardLoading = true;

      helper.createCardAndMakePayment(
          submitCardPayload.nameOnCard,
          submitCardPayload.pan,
          submitCardPayload.cvv,
          submitCardPayload.year,
          submitCardPayload.month,
          submitCardPayload.amount,
          submitCardPayload.addressId,
          submitCardPayload.useForFuturePayments,
      )
             // .then(response => this.getUserInfo().then(r => response))
       .then((response) => {
          this.worldpay3dsUrl = response.data.worldpay3dsUrl;

          this.worldpay3dsIframeVisible = true;
          this.paymentNewCardLoading = false;

         if (response.data.error === true) {
           this.addMessage({title: 'Something went wrong', type: 'error'});
         }

      }).catch(error => {
        console.log('err', error);
        this.paymentNewCardLoading = false
      });
    },
    processRegisteredCardPayment: function (payload) {
      let submitCardPayload = {
        cvv: payload.cvv,
        paymentMethodId: payload.registeredPaymentMethodId,
        amount: this.getSelectedAmount()
      };


      if (submitCardPayload.cvv) {
        this.paymentRegisteredCardLoading = true;

        helper.validateCardAndCreatePayment(
            submitCardPayload.paymentMethodId,
            submitCardPayload.cvv,
            submitCardPayload.amount
        ).then((response) => {
          this.addMessage(response.data.messages);

          let input = document.querySelector('.process-paymnet-cvv');

          if (response.data.cardIsValid === false) {
            input.classList.add('alert');
            throw new Error("Given card is not valid, cannot do a payment at this time.");
          }

          input.classList.remove('alert');

          this.worldpay3dsUrl = response.data.worldpay3dsUrl;

          if (!this.worldpay3dsUrl) {
            input.classList.add('alert');
            throw new Error("Missing 3ds url");
          }

          this.worldpay3dsIframeVisible = true;
          this.paymentRegisteredCardLoading = false;
          //
          // if (response.data.error !== true) {
          //   this.planSummaryVisible = true;
          //   this.paymentVisible = false;
          // }
        }).catch((e) => {
          this.paymentRegisteredCardLoading = false;
        });
      }
    },
    resetNewCardForm: function () {
      this.$refs.newCardRef.resetForm();
      this.selectedAddress = null;
    },
    getSelectedAmount: function () {
      let amount = 0;

      switch (this.amountType) {

        case 'full':
          amount = this.fullAmountValue;
          break;
        case 'custom':
          amount = this.customAmountValue;
          break;
        case 'instalment':
          amount = this.outstandingBillAmountValue;
          break;
      }
      return amount;
    },
    sofortMakePayment: function () {
      $('.processPayment .btn.sofortMakePayment, .processPayment .btn.process').addClass('disabled').addClass('hide');
      this.loading = true;
      this.redirectWithPost('/auth/payment-method/sofort', {
        '_token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'amount': this.getSelectedAmount()
      }, 'post');
    },
    /**
     * sends a request to the specified url from a form. this will change the window location.
     * @param {string} path the path to send the post request to
     * @param {object} params the paramiters to add to the url
     * @param {string} [method=post] the method to use on the form
     */
    redirectWithPost: function (path, params, method = 'post') {
      // The rest of this code assumes you are not using a library.
      // It can be made less wordy if you use one.
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    },

    handleSofortMessage: function (title, type) {
      this.addMessage({title, type});
    },

    sofortListenUrl: function (url) {
      return axios.get(url).then(res => {
        if (res.data === 103) {
          this.handleSofortMessage(window.lang.get('pages/payment.sofortSuccess'), 'info');
          clearInterval(this.sofortListenUrlIntervalRef);

          // TODO refactor this
          $('.messageNotification.progress').remove();
        }
      }).catch(e => {
        console.log(e);
      })
    },

    handleSofort: function () {
      $('.menu .navigation li.payment a').addClass('active');
      const url_string = window.location.href;
      const url = new URL(url_string);
      const loan = url.searchParams.get("loan");
      // const payment = url.searchParams.get("payment");
      const status = url.searchParams.get("status");
      const listen_url = url.searchParams.get("listen_url");

      const userMatch = this.user.cards.filter(card => {
        return card.loan === loan;
      }).length > 0;

      if (userMatch && status) {

        if (status === 'success' && !listen_url) {
          this.handleSofortMessage(window.lang.get('pages/payment.sofortSuccess'), 'info');
        }
        if (status !== 'success') {
          this.handleSofortMessage(window.lang.get('pages/payment.sofortError'), 'error');
        }

        if (listen_url) {
          this.handleSofortMessage(window.lang.get('pages/payment.payment-in-progress'), 'progress');

          this.sofortListenUrlIntervalRef = setInterval(() => {
            this.sofortListenUrl(listen_url);
          }, 10000);
        }
      }

      return false;
    },

    worldpay3dsEvent: function (r) {
      if (r === 'error') {
        this.worldpay3dsIframeVisible = false;
        this.addMessage({title: 'Something went wrong', type: 'error'});

      } else if (r === 'success') {
        this.getUserInfo().then(() => {
          this.worldpay3dsIframeVisible = false;
        //  this.addMessage({title: 'Great success', type: 'success'});

          this.planSummaryVisible = true;
          this.paymentVisible = false;

          this.resetNewCardForm();

          setTimeout(() => {
			  this.$router.push('/');
		  }, 2000);
        })
      }
    }
  },
  computed: {
    ...mapState(['paymentInstalmentLoading', 'user', 'paymentActiveCardLoading', 'addressBook', 'messages', 'language']),
    selectedAmount: function () {
      return this.getSelectedAmount()
    },
    addresses: function () {
      let addresses = [];
      this.addressBook.forEach(function (address) {
        addresses.push({
          value: address.id,
          label: address.full_address
        });
      });
      return addresses;
    },
    loader: function () {
      return this.loading ? true : false;
    }
  },
  watch: {
    selectedAddress: function (newValue) {
      if (newValue) {
        this.billingAddressError = false
      }
    },
    'user.account_balance': {
      immediate: true,
      handler: function (val) {
        this.fullAmountValue = val;
      }
    },
    'user.instalment.amount': {
      immediate: true,
      handler: function (val) {
        this.instalmentAmountValue = val;
      }
    },
  },
  created() {

    this.getRegisteredActiveCard().then((response) => {
      if (this.user.activeCard) {
        this.registeredCardPan = this.user.activeCard.pan;
        this.registeredPaymentMethodId = this.user.activeCard.id;
      }
    });

    this.getUserInfo().then((response) => {
      this.userDataloaded = true;

      this.instalmentAmountValue = this.getInstalmentAmount();
      this.outstandingBillAmountValue = this.getOutstandingBillAmount();
      this.jurisdiction = this.getJurisdiction();
      this.fullAmountValue = parseFloat(this.user.account_balance);

      this.handleSofort();

      if (!this.user.account_balance || this.user.account_balance === 0) {
        this.$router.push('/');
      }
    });

    if (this.addressBook.length === 0) {
      this.getAddresses();
    }

    this.paymentVisible = true;
    this.planSummaryVisible = false;

  },
  beforeDestroy() {
    $('.menu .navigation li.payment a').removeClass('active');
    clearInterval(this.sofortListenUrlIntervalRef);

  }
}
</script>
